import { useCallback, useEffect, useState } from "react";
import { insights as fallbackInsights } from "../data/insights";

const dateValue = (item) => {
  const value = Date.parse(`${item?.dateTime || ""}T00:00:00.000Z`);
  return Number.isFinite(value) ? value : Date.parse(item?.createdAt || "") || 0;
};

const sortByPublicationDate = (items) => [...items].sort((left, right) => dateValue(right) - dateValue(left));

export const useInsights = () => {
  const [items, setItems] = useState(() => sortByPublicationDate(fallbackInsights));
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const response = await fetch("/api/insights", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!response.ok) throw new Error("News service is unavailable");
      const data = await response.json();
      if (Array.isArray(data.items)) setItems(sortByPublicationDate(data.items));
    } catch (error) {
      // The published fallback keeps the public page useful if the API is restarting.
      console.warn("Using bundled insights fallback:", error.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { items, isLoading, refresh };
};
